// extracted by mini-css-extract-plugin
export default {"section-title":"FormSection_section-title__eKWO2","container":"FormSection_container__GWtD1","legend":"FormSection_legend__b6UAv"};